// extracted by mini-css-extract-plugin
export default {"body":"LoginForm_body__-Jk6j","btn":"LoginForm_btn__GQFA5"};